module.exports = __webpack_public_path__ + "img/thumbnail_CollaredPeccary_j_leucistic.fbbbe04a.png";